import React, { Component } from 'react';
import map from 'lodash/map';
import BloxGrid from 'sub_components/Layout/BloxMicroGrid';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { ToggleButton } from 'styled_components/Common/ToggleButton';
import { IconButton } from 'styled_components/Common/IconButton';
import { CogSVG } from 'styled_components/SVG/CogSVG';
import { GuestAccessSVG } from 'styled_components/SVG/GuestAccess';
import { RESOLUTIONS } from 'services/config';
import { ThemeProvider } from 'styled-components';
import { DailySelector } from 'styled_components/SVG/DailySelector';
import { DailyTest } from 'styled_components/SVG/DailyTest';
import { PieSelector } from 'styled_components/SVG/PieChart';
import { BarSelector } from 'styled_components/SVG/BarChart';
import { TrendSelector } from 'styled_components/SVG/TrendSelector';
//import { EditAvatar } from 'styled_components/EditAvatar';
import { AvatarApi } from 'services/avatar';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};

const theme2 = {
	account: 'red',
	support: 'blue',
	storage: 'green',
	billing: 'orange',
};

const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 5,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 3,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};

export default class Sandbox extends Component {
	constructor(props) {
		super(props);

		this.screenObserver = null;
		this.state = {
			breakpoint: RESOLUTIONS.MED,
			screenWidth: null,
			theme: theme1,
			position: 'left',
			position4: 'left',
			showToggle: 'two',
			niamh: 'EDIT ME',
		};
	}

	updateScreenBreakpoint = (screenWidth, screenHeight) => {
		let breakpoint = RESOLUTIONS.MED;

		if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
			breakpoint = RESOLUTIONS.LOW;
		} else if (screenWidth > RESOLUTIONS.MED && screenWidth <= RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.MED;
		} else if (screenWidth > RESOLUTIONS.HIGH) {
			breakpoint = RESOLUTIONS.HIGH;
		} else {
			breakpoint = RESOLUTIONS.MIN;
		}

		this.setState({ breakpoint, screenWidth, screenHeight }, () => {
			//this.getInteriorWall(screenWidth, screenHeight);
		});
	};

	componentDidMount() {
		// Parse URL to determine module to load...

		this.screenObserver = new ResizeObserver(entries => {
			entries.forEach(entry => {
				const screenWidth = entry.contentRect.width;
				const screenHeight = entry.contentRect.height;
				this.updateScreenBreakpoint(screenWidth, screenHeight);
			});
		});

		const htmlEl = document.querySelector('html');
		this.screenObserver.observe(htmlEl);
	}

	clicky = id => {
		const element = document.getElementById(id);
		element.classList.toggle('active');
		document.getElementById(`${id}trans2`).beginElement();
		if (document.getElementById(`${id}trans3`)) {
			document.getElementById(`${id}trans3`).beginElement();
		}
	};

	transitionImageOver = id => {
		const isIE = /*@cc_on!@*/ false || !!document.documentMode;
		// Edge 20+
		const isEdge = !isIE && !!window.StyleMedia;
		const windows = isIE || isEdge;
		if (windows) {
			document.getElementById('issue-request-component-wrapper').classList.add('windows');
		} else {
			document.getElementById(`${id}trans1`).beginElement();
		}
	};
	changeTheme = () => {
		this.setState({ theme: theme2 });
	};
	defaultTheme = () => {
		this.setState({ theme: theme1 });
	};
	checkSliderPosition = element => {
		let position = 'left';
		if (!element.classList[0].includes('1')) {
			if (element.classList[0].includes('2')) {
				position = 'right';
			} else if (element.classList[0].includes('3')) {
				position = 'right';
			} else if (element.classList[0].includes('0')) {
				position = 'left';
			}

			this.setState({ position });
		}
	};
	checkSliderPosition4 = element => {
		let position4 = 'left';
		if (!element.classList[0].includes('1') && !element.classList[0].includes('2')) {
			if (element.classList[0].includes('2')) {
				position4 = 'right';
			} else if (element.classList[0].includes('3')) {
				position4 = 'right';
			} else if (element.classList[0].includes('0')) {
				position4 = 'left';
			}

			this.setState({ position4 });
		}
	};
	getAvatars = () => {
		const avatars = new AvatarApi().getAll();

		return map(avatars, (avatar, index) => {
			return (
				<ActionButton
					key={avatar}
					className='avatar-selector'
					style={{ backgroundImage: avatar }}
					//onClick={onClick(index)}
					data-cy={`avatar-${index}`}
				>
					<img src={avatar} alt='avatar' data-cy={`avatar-image-${index}`} />
				</ActionButton>
			);
		});
	};

	changeView = view => {
		this.setState({ showToggle: view });
	};
	getLayoutConfig = breakpoint => {
		const config = LAYOUT_CONFIG[breakpoint];

		return config;
	};
	changeNiamh = e => {
		console.log('val1', e.target.value);
		this.setState({ niamh: e.target.value });
	};

	render() {
		const grid = [{ i: 'sandbox', x: 0, y: 0, w: 1000, h: 1000, static: true }];
		const { theme, breakpoint, position, position4, showToggle } = this.state;

		return (
			<div className='sandbox-wrapper'>
				<BloxGrid name='sandbox-grid' parentEl='.sandbox-wrapper' contentGrid={grid}>
					<div key='sandbox' id='sandbox' className='sandbox'>
						<div className='neo'>
							<div>NEUMORPHISM</div>
						</div>
						<h1>Neomorphic Buttons - Styled components</h1>
						{/* <EditAvatar renderContent={this.getAvatars} /> */}
						<div>
							<Carousel responsive={responsive} itemClass='carousel-item-padding-40-px'>
								<div className='square'>Item 1</div>
								<div className='square'>Item 2</div>
								<div className='square'>Item 3</div>
								<div className='square'>Item 4</div>
							</Carousel>
							<div class='flex-1'>
								<ThemeProvider theme={theme}>
									<div className='section'>
										<ActionButton
											id='special-id-1'
											onClick={() => this.clicky('special-id-1')}
											onMouseOver={() => this.transitionImageOver('special-id-1')}
											module='support'
										>
											<CogSVG id='special-id-1' />
										</ActionButton>
										<ActionButton
											module='support'
											className='medium'
											id='special-id-2'
											onClick={() => this.clicky('special-id-2')}
											onMouseOver={() => this.transitionImageOver('special-id-2')}
										>
											<CogSVG className='medium' id='special-id-2' />
										</ActionButton>
										<ActionButton
											module='support'
											className='large'
											id='special-id-3'
											onClick={() => this.clicky('special-id-3')}
											onMouseOver={() => this.transitionImageOver('special-id-3')}
										>
											<CogSVG className='large' id='special-id-3' />
										</ActionButton>
									</div>
									<div className='section'>
										<ActionButton
											module='support'
											id='special-id-4'
											onClick={() => this.clicky('special-id-4')}
											onMouseOver={() => this.transitionImageOver('special-id-4')}
										>
											<GuestAccessSVG id='special-id-4' breakpoint='sm' />
										</ActionButton>
										<ActionButton
											module='support'
											className='medium'
											id='special-id-5'
											onClick={() => this.clicky('special-id-5')}
											onMouseOver={() => this.transitionImageOver('special-id-5')}
										>
											<GuestAccessSVG className='medium' id='special-id-5' breakpoint='md' />
										</ActionButton>
										<ActionButton
											module='support'
											className='large'
											id='special-id-6'
											onClick={() => this.clicky('special-id-6')}
											onMouseOver={() => this.transitionImageOver('special-id-6')}
										>
											<GuestAccessSVG className='large' id='special-id-6' breakpoint='l' />
										</ActionButton>
									</div>
								</ThemeProvider>
							</div>

							<h1>
								Action Buttons - Styled component.(Using Theme - this would be our default theme.){' '}
							</h1>

							<div className='flex'>
								<div className='section'>
									<h4>Change Theme </h4>
									<ThemeProvider theme={theme}>
										<BloxButton
											id='button-1568'
											text='Change Theme'
											breakpoint={930}
											module='storage'
											enabled={true}
											className='buttons41'
											onClick={this.changeTheme}
										/>
										<BloxButton
											id='button-15689'
											text='Default Theme'
											breakpoint={930}
											module='storage'
											enabled={true}
											className='buttons41'
											onClick={this.defaultTheme}
										/>
									</ThemeProvider>
								</div>

								<div className='section'>
									<h4>1024</h4>
									<ThemeProvider theme={theme}>
										<BloxButton
											id='button-1'
											text='TENLETTERS'
											breakpoint={930}
											module='storage'
											enabled={true}
											className='buttons41'
										/>

										<BloxButton
											text='12 LTR/SPACE'
											breakpoint={930}
											module='billing'
											enabled={true}
											id='button-2'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={930}
											module='account'
											enabled={true}
											id='button-3'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={930}
											module='support'
											enabled={true}
											id='button-4'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={930}
											module='support'
											enabled={false}
											id='button-41'
											className='buttons41'
										/>
									</ThemeProvider>
								</div>

								<div className='section'>
									<h4>1440</h4>
									<ThemeProvider theme={theme}>
										<BloxButton
											id='button-5'
											text='TENLETTERS'
											breakpoint={1344}
											module='storage'
											enabled={true}
											className='buttons41'
										/>

										<BloxButton
											text='12 LTR/SPACE'
											breakpoint={1344}
											module='billing'
											enabled={true}
											id='button-6'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={1344}
											module='account'
											enabled={true}
											id='button-7'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={1344}
											module='support'
											enabled={true}
											id='button-8'
											className='buttons41'
											disableAfterClick={true}
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={1344}
											module='support'
											enabled={false}
											id='button-81'
											className='buttons41'
											disableAfterClick={true}
										/>
									</ThemeProvider>
								</div>

								<div className='section'>
									<h4>2560</h4>
									<ThemeProvider theme={theme}>
										<BloxButton
											id='button-9'
											text='TENLETTERS'
											breakpoint={2240}
											module='storage'
											enabled={true}
											className='buttons41'
										/>

										<BloxButton
											text='12 LTR/SPACE'
											breakpoint={2240}
											module='billing'
											enabled={true}
											id='button-10'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={2240}
											module='account'
											enabled={true}
											id='button-11'
											className='buttons41'
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={2240}
											module='support'
											enabled={true}
											id='button-12'
											className='buttons41'
											disableAfterClick={true}
										/>
										<BloxButton
											text='1414 LTR/SPACE'
											breakpoint={2240}
											module='support'
											enabled={false}
											id='button-121'
											className='buttons41'
											disableAfterClick={true}
										/>
									</ThemeProvider>
								</div>
							</div>
							<h1>Toggle Button - Styled component.</h1>
							<div className='flex'>
								<div className='section'>
									<ThemeProvider theme={theme}>
										<BloxButton
											text='Show Toggle 2'
											breakpoint={breakpoint}
											module='support'
											enabled={true}
											id='button-1216'
											className='buttons41'
											onClick={() => this.changeView('two')}
										/>
										<BloxButton
											text='Show Toggle 3'
											breakpoint={breakpoint}
											module='support'
											enabled={true}
											id='button-1214'
											className='buttons41'
											onClick={() => this.changeView('three')}
										/>
										<BloxButton
											text='Show Toggle 4'
											breakpoint={breakpoint}
											module='support'
											enabled={true}
											id='button-1213'
											className='buttons41'
											onClick={() => this.changeView('four')}
										/>
									</ThemeProvider>
								</div>

								<div className='section'>
									<ThemeProvider theme={theme}>
										{showToggle === 'two' && (
											<ToggleButton
												module='storage'
												id='toggle-slider'
												theme={theme}
												groupName='togglers-1'
												breakpoint={breakpoint}
											>
												<BarSelector
													id='bar-selector-1'
													module='storage'
													theme={theme}
													className={'bar'}
												/>
												<PieSelector
													id='pie-selector-1'
													module='storage'
													theme={theme}
													className={'pie'}
												/>
											</ToggleButton>
										)}
										{showToggle === 'three' && (
											<ToggleButton
												module='storage'
												id='toggle-slider-2'
												theme={theme}
												groupName='togglers-2'
												breakpoint={breakpoint}
												checkSlider={this.checkSliderPosition}
											>
												<BarSelector
													id='bar-selector-2'
													module='storage'
													theme={theme}
													className={'bar-2'}
												/>
												<DailySelector
													id='daily-selector-1'
													module='storage'
													theme={theme}
													position={position}
													className={'daily'}
												/>
												<PieSelector
													id='pie-selector-2'
													module='storage'
													theme={theme}
													className={'pie-2'}
												/>
											</ToggleButton>
										)}
										{showToggle === 'four' && (
											<ToggleButton
												module='storage'
												id='toggle-slider'
												theme={theme}
												groupName='togglers-3'
												breakpoint={breakpoint}
												checkSlider={this.checkSliderPosition4}
											>
												<BarSelector
													id='bar-selector-3'
													module='storage'
													theme={theme}
													className={'bar-3'}
												/>
												<DailySelector
													id='daily-selector-2'
													module='storage'
													theme={theme}
													position={position4}
													className={'daily-2'}
												/>
												<TrendSelector
													id='trend-selector-1'
													module='storage'
													theme={theme}
													position={position4}
													className={'trend'}
												/>
												<PieSelector
													id='pie-selector-3'
													module='storage'
													theme={theme}
													className='pie-3'
												/>
											</ToggleButton>
										)}
									</ThemeProvider>
								</div>
							</div>
							<br />
							<h1>Icon Buttons</h1>
							<div className='flex-3'>
								<div className='section'>
									<ThemeProvider theme={theme}>
										<IconButton
											svgId='daily-selector-3'
											enabled={true}
											id='icon-button'
											module='storage'
											breakpoint={930}
										>
											<DailyTest
												id='daily-selector-3'
												module='storage'
												theme={theme}
												position={position4}
												className={'daily'}
											/>
										</IconButton>
										<br />
										<IconButton
											enabled={true}
											id='icon-button-2'
											module='storage'
											breakpoint={1344}
											svgId='daily-selector-3'
										>
											<DailyTest
												id='daily-selector-3'
												module='storage'
												theme={theme}
												position={position4}
												className={'daily'}
											/>
										</IconButton>
										<br />
										<IconButton
											svgId='daily-selector-3'
											enabled={true}
											id='icon-button-3'
											module='storage'
											breakpoint={2240}
										>
											<DailyTest
												id='daily-selector-3'
												module='storage'
												theme={theme}
												position={position4}
												className={'daily'}
											/>
										</IconButton>
									</ThemeProvider>
								</div>
							</div>
						</div>
					</div>
				</BloxGrid>
			</div>
		);
	}
}
